module.exports = __webpack_public_path__ + "img/avatar-generic.8cd2ba01.svg";